import { Component, Input, OnInit } from "@angular/core";
import { ModalController } from "@ionic/angular";
import { TextbausteinPlatzhalter } from "../enums/global-enums";

@Component({
  selector: "app-platzhalter-autofill-info-modal",
  templateUrl: "./popup-info-modal.component.html",
  styleUrls: ["./popup-info-modal.component.scss"],
  standalone: false,
})
export class PopupInfoModalComponent {
  @Input() title: string;
  @Input({ required: true }) text: string;

  constructor(private modalController: ModalController) {}

  cancelButton() {
    this.modalController.dismiss(null, "cancel");
  }

  protected readonly Object = Object;
}
